import {HotelsReviewInitialState, ReviewPageActionTypes} from './hotels-review-types';
import {charityDetailsFn} from './hotels-review-selectors';
import {titlesMap} from '@stencil/hotels-utils/src/common-utils';

import {
  UPDATE_DESCBLOCK_DATA,
  UPDATE_DESCBLOCK_INPUT,
  UPDATE_HOTELS_PAYMENTS_DATA,
  UPDATE_HOTELS_PAYMENT_OPEN_CLOSE_STATUS,
  UPDATE_USEGOCASH_STATUS,
  RESET_PAYMENTS_DATA,
  UPDATE_DESCBLOCK_LOADING_STATUS,
  UPDATE_EARLYCHECKIN_STATUS,
  UPDATE_COUNTRY_CODES,
  UPDATE_HOTELS_POLICY,
  RESET_REVIEW_PAGE_DATA,
  TOGGLE_AGREE_TNC,
  UPDATE_OFFERS_FROM_HERMES,
  UPDATE_DONATE_CHARITY_STATUS,
  UPDATE_ACTIVE_PAYMODE,
  TOGGLE_POLICIES_MODAL,
} from './constants';

const initialState: HotelsReviewInitialState = {
  //input
  descblockInput: {
    hc: '',
    vert: 'hotels',
    strQry: '',
    v: '',
    rtc: '',
    rpc: '',
    fwdParams: '',
    newui: 'true',
    // vcid: '',
    pah: '',
    code: '',
    ext: false,
    pay_mode: '',
    paxString: '',
    gds: '',
    rtn: '',
    gseg: '',
    cot: '',
    hmd: '',
    gsv: '',
    hOfferCode: '',
    hotelArea: '',
    cityCode: '',
    hotelName: '',
    gtv: '',
    openOfferSuccessModal: false,
    // rwt: '',
  },
  descblockResponse: {
    loading: true,
  },
  //descblock
  //hotelspayment
  paymentsData: {
    loading: false,
  },
  paymentOpen: false,
  useGoCash: true,
  earlycheckin: false,
  countryCodes: [],
  policies: {
    loading: false,
    error: false,
  },
  agreeTnC: true,
  donate: false,
  offers: {
    promo_list: [],
    uph: [],
    loading: false,
  },
  openPolicies: false,
  //offers
  // profileType: false,
};

export default function reviewReducer(state = initialState, action: ReviewPageActionTypes) {
  switch (action.type) {
    case UPDATE_DESCBLOCK_DATA:
      const descblockResponse = action.actionData;
      const charityDetails = charityDetailsFn(descblockResponse?.cdata) || {};
      const donateCharity = !!charityDetails?.is_pre_check;
      return {
        ...state,
        descblockResponse,
        donate: donateCharity,
      };
    case UPDATE_DESCBLOCK_INPUT:
      return {
        ...state,
        descblockInput: {...state.descblockInput, ...action.actionData},
      };
    case UPDATE_DESCBLOCK_LOADING_STATUS:
      return {
        ...state,
        descblockResponse: {...state.descblockResponse, loading: action.status},
      };
    case UPDATE_HOTELS_PAYMENTS_DATA:
      return {
        ...state,
        paymentsData: action.actionData,
      };
    case UPDATE_HOTELS_PAYMENT_OPEN_CLOSE_STATUS:
      return {
        ...state,
        paymentOpen: action.status,
      };
    case UPDATE_USEGOCASH_STATUS:
      return {
        ...state,
        useGoCash: action.status,
      };
    case RESET_PAYMENTS_DATA:
      return {
        ...state,
        paymentsData: {loading: false},
        paymentOpen: false,
      };
    case UPDATE_EARLYCHECKIN_STATUS:
      return {
        ...state,
        earlycheckin: action.status,
      };
    case UPDATE_COUNTRY_CODES:
      return {
        ...state,
        countryCodes: action.actionData,
      };
    case UPDATE_HOTELS_POLICY:
      return {
        ...state,
        policies: action.actionData,
      };
    case RESET_REVIEW_PAGE_DATA:
      return {
        ...initialState,
        countryCodes: state.countryCodes,
      };
    case TOGGLE_AGREE_TNC:
      return {
        ...state,
        agreeTnC: action.actionData,
      };
    case UPDATE_OFFERS_FROM_HERMES:
      return {
        ...state,
        offers: {...state.offers, ...action.actionData},
      };
    case UPDATE_DONATE_CHARITY_STATUS:
      return {
        ...state,
        donate: action.actionData,
      };
    case UPDATE_ACTIVE_PAYMODE:
      if (state?.descblockResponse?.cdata)
        return {
          ...state,
          descblockResponse: {
            ...state.descblockResponse,
            cdata: {...state.descblockResponse.cdata, pay_mode: action.actionData},
          },
        };
    case TOGGLE_POLICIES_MODAL:
      return {
        ...state,
        openPolicies: action.actionData,
      };
    default:
      return state;
  }
}
